/** @flow */
import client, { clientMessages } from "@modules/client/translations";
import hierarchy, { hierarchyMessages } from "@modules/hierarchy/translations";
import employee, { employeeMessages } from "@modules/employee/translations";
import home from "@modules/home/translations";
import login from "@modules/account/translations";
import management, { managementMessages } from "@modules/management/translations";
import profile, { profileMessages } from "@modules/profile/translations";
import recording, { recordingMessages } from "@modules/recording/translations";
import reporting, { reportingMessages } from "@modules/reporting/translations";
import components from "@components/translations";
import service, { serviceMessages } from "@modules/service/translations";
import data from "@modules/data/translations";
import training from "@modules/training/translations";
import changelog from "@components/change-log/translations";
import { checkboxGroupTranslations } from "@components";
import shared from "@modules/shared/translations";

export const translations = {
  en: {
    ...client.en,
    ...hierarchy.en,
    ...employee.en,
    ...home.en,
    ...login.en,
    ...management.en,
    ...profile.en,
    ...recording.en,
    ...reporting.en,
    ...components.en,
    ...service.en,
    ...data.en,
    ...changelog.en,
    ...shared.en,
    ...checkboxGroupTranslations.en,
    ...training.en,
    // Common
    HOME: "Home",
    CENTRAL: "Central",
    HEALTH: "Health",
    ONE_MOMENT_PLEASE: "One moment please...",
    ADMINISTRATION: "Administration",
    GOOD_SHAPE_APP: "GoodShape App",
    LEARN_MORE: "Learn more!",
    ACTION: "Action",
    ACTIVE: "Active",
    NOT_ACTIVE: "Not Active",
    LOCKED: "Locked",
    LOCK: "Lock",
    UNLOCK: "Unlock",
    UNLOCKED: "Unlocked",
    UNREGISTERED: "Unregistered",
    BRAND_NAME: "GoodShapeCentral!",
    BRAND_HEADING: "Absence Management Solution",
    TRANSFER_ABSENCE: "Transfer Absence",
    CTRL_ENTER_TO_SUBMIT: "Ctrl+Enter to Submit",
    GO_TO_PAGE: "Go to Page",
    GO: "Go",
    LOW_RES_BANNER_TEXT:
      "We have detected that you are using a device with a limited screen width. To get the best user experience consider adjusting your zoom to 80%.",
    CHANGE: "Change",
    CHANGE_CLIENT: "Change Client",
    CHANGE_EMPLOYEE: "Change Employee",
    INACTIVE: "Inactive",
    NON_SERVICE_USER: "Non Service User",
    MANAGEMENT: "Management",
    RECORDING: "Recording",
    REPORTING: "Reporting",
    STATUS: "Status",
    CREATED_BY: "Created By",
    END_DATE: "End Date",
    VALUE: "Value",
    FIRSTCARE_LTD_2019_ALL_RIGHTS_RESERVED: "GoodShape Ltd 2019. All Rights Reserved",
    PRIVACY: "Privacy",
    ABOUT_US: "About Us",
    ABSENCE_MANAGEMENT_SOLUTIONS: "Absence Management Solutions",
    // Changelog Table
    DATE_CHANGED: "Date Changed",
    CHANGED_BY: "Changed By",
    CHANGED_AT: "Changed At",
    SUBMITTED_BY: "Submitted By",
    SUBMITTED_AT: "Submitted At",
    NUMBER_OF_CHANGES: "Number Of Changes",
    VALUE_CHANGED: "Value Changed",
    OLD_VALUE: "Old Value",
    NEW_VALUE: "New Value",
    // Form
    BACK: "Back",
    SUBMIT: "Submit",
    RESET: "Reset",
    EXPORT: "Export",
    EXPAND: "Expand",
    VIEW: "View",
    EDIT: "Edit",
    DUPLICATE: "Duplicate",
    EDIT_DETAILS: "Edit Details",
    MANAGE: "Manage",
    SEARCH: "Search",
    SEARCH_DOTS: "Search...",
    REVERT: "Revert",
    CANCEL: "Cancel",
    REMOVE: "Remove",
    SAVE: "Save",
    APPLY_FILTERS: "Apply Filters",
    ALL: "All",
    SELECT: "Select",
    SEARCH_RESULTS: "Search Results",
    DISABLE: "Disable",
    ENABLE: "Enable",
    DISMISS: "Dismiss",
    ARE_YOU_SURE: "Are you sure?",
    ATTENTION: "Attention",
    CLOSE: "Close",
    SEARCH_AGAIN: "Search Again",
    "N/A": "N/A",
    NAME: "Name",
    IMAGE: "Image",
    FILE_NAME: "File Name",
    NEXT: "Next",
    FAILED: "Failed",
    FAILURE: "Failure",
    SUCCESS: "Success",
    CONTINUE: "Continue",
    OPEN: "Open",
    OPERATION: "Operation",
    DATE_AND_TIME: "Date and Time",
    DAY: "Day",
    DATE: "Date",
    DATE_FROM: "Date From",
    DATE_TO: "Date To",
    DOWNLOAD: "Download",
    ENABLED: "Enabled",
    DISABLED: "Disabled",
    PERIOD: "Period",
    SUBMIT_CHANGES: "Submit Changes",
    DISCARD_DRAFT: "Discard Draft",
    JUMP_TO: "Jump to",
    DELETE_SELECTED: "Delete Selected",
    ADD_NEW: "Add New",
    RESULTS: "Results",
    // Select client bar
    SELECT_CLIENT_BAR_PLACEHOLDER: "Select Client / Type to Search",
    SURNAME: "Surname",
    LAST_NAME: "Last Name",
    TRAINING: "Training",
    INSIGHT_TRAINING_HUB: "Insight Training Hub",
    TRAINING_HUB: "Training Hub",
    CONTACT_US: "Contact Us",
    PLEASE_APPLY_QUESTION_OR: "Please apply question or",
    NEED_HELP: "Need help?",
    NEED_MORE_HELP: "Need more help?",
    HOW_CAN_WE_HELP: "How can we help?",
    SEARCH_THE_LIST_OF_TOPICS_ON_THE_LEFT_TO_GET_STARTED:
      "Search the list of topics on the left to get started.",
    WATCH_VIDEO: "Watch Video",
    LATEST_RELEASE_NOTES: "Latest Release Notes",
    VIDEOS: "Videos",
    BASIC_TUTORIALS: "Basic Tutorials",
    TUTORIALS: "Tutorials",
    ADVANCED_TUTORIALS: "Advanced Tutorials",
    LOGOUT_SIGN: "Log Out",
    TUTORIAL_INTRODUCTION: "Introduction",
    TUTORIAL_RUNNING_REPORTS: "Running Reports",
    TUTORIAL_RTW_INTRVIEWS: "RTW Interviews",
    HOW_TO_SCHEDULE_REPORTS: "How to Schedule Reports",
    TUTORIAL_EMPLOYEE_RECORDS: "Employee Records",
    TUTORIAL_ABSENCE_RATES: "Absence Rates",
    TUTORIAL_ABSENCE_RATES_2: "Absence Rate Part 2",
    TUTORIAL_ABSENCE_RATES_1: "Absence Rate Part 1",
    TUTORIAL_RUNNING_PRESENTATIONS: "Running Presentations",
    EDITING_CHARTS: "Editing Charts",
    COMING_SOON: "Coming Soon",
    USER_GUIDE: "User Guide",
    ACCESS_TYPES: "Access Types",
    HOME_TITLE_WELCOME: "Hello, {name}",
    WELCOME_TO_GOOD_SHAPE_CENTRAL: "Welcome to GoodShape!",
    GSC_APP_MESSAGE:
      "It seems you have accessed the wrong GoodShape system. Please click on the <b>'Go to GoodShape Central'</b> button to access the <b>Administration</b> and <b>Reporting</b> sections...",
    GO_TO_GSC: "Go to GoodShape Central",
    HOME_WELCOME_TO_INSIGHT_FIRST_LOGIN_TEXT:
      "Thank you for registering your account on GoodShapeCentral. We have prepared a series of tutorials to guide you through the system. Would you like to view these now? If not, you can find them any time by visiting the Training page.",
    FIND_THEM_LATER: "No, Find Them Later",
    VIEW_NOW: "Yes, View Tutorials Now",
    ACCESS_TOOLS: " account which allows you to access the following tools...",
    YOU_HAVE_A: "You have a ",
    MONITORING_TITLE: "Monitoring",
    ABSENCE_MONITORING_HISTORY: "Absence Monitoring History",
    OTHER_ACTIVITIES: "Other Activities",
    FINAL_RTW_DATE: "Final RTW Date",
    DAYS_CHANGE: "Days Change",
    BY_PHONE: "By Phone",
    BY_EMAIL: "By Email",
    OPTIONS: "Options",
    NAVIGATE: "Navigate",
    OUR_CUSTOMER_SUPPORT_LINE_AVAILABLE:
      "Our Customer Support Line is available Monday to Friday 9:00am to 5:00pm.",

    EMPLOYEE_REFERRAL: "Employee Referral",
    MANAGER_REFERRAL: "Manager Referral",
    MANUAL_REFERRAL: "Manual Referral",

    // Days of the Week
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",

    // Session
    SESSION_EXPIRES_IN_FORMATTED_TIME: "Session expires in {formattedTime}",
    PAGE_NOT_FOUND: "Page Not Found",
    NO_SHIFT_PATTERN_FOUND:
      "No shift pattern has been recorded for this absence, please select the 'Edit Pattern' button to update this record",
    REMEMBER_TO_ADD_A_SHIFT_PATTERN_TO_THE_ABSENCE:
      "Remember to add a shift pattern to the absence by selecting the magnifying glass on the following page",
    COLLAPSE: "Collapse",
    BACK_TO_TOP: "Back To Top",
    THERE_ARE_OUTSTANDING_TASKS: `There are <span class="text-color-pumpkin-orange">{tasksCount}</span> outstanding tasks.`,
    NO_OUTSTANDING_TASKS: `Good news! There are no outstanding tasks for this employee.`,
    ADD_NEW_NOTE: `Add New Note`,
    ADD_NOTE: `Add Note`,
    RELEVANT_ABSENCE: `Relevant Absence`,
    ABSENCE_NOTE_TYPE: `Absence Note Type`,
    RELEVANT_ABSENCE_DROPDOWN_ITEM: `Absence ID: {id} (Start Date: {startDate})`,
    SELECT_EMPLOYEE_TO_TRANSFER_ABSENCE_TO: `1/2 Select Employee To Transfer Absence To`,
    SELECT_POSITION_TO_ASSIGN_SHIFT_PATTERN_TO: `2/2 Select Position to Assign Shift Pattern To`,
    TRANSFER_ABSENCE_CONFIRMATION_TEXT: `Are you sure you want to transfer Absence ID {absenceId} from {fromName} to {toName} ?`,
    NON_ABSENCE_SPECIFIC: "Non-Absence Specific",
    DELETE_NOTE: "Delete Note",
    CONFIRM_NOTE_DELETION: "Are you sure you want to delete this note ?",
    SEARCH_EMPLOYEE_SURNAME: "Search employee surname...",
    NO_ACCESS_TEXT: "User does not have permission to access.",

    // Administration
    CLIENT_ADMIN_ACTION_TEXT: "Go to Client",
    CLIENT_ADMIN_DESCRIPTION:
      "Edit the details, services and SLA measures of a client, and review their self-service requests.",
    DATA_ADMIN_DESCRIPTION:
      "Here you can administer the GoodShape service, including all hierarchy, service, employee and data admin. Here you can perform loading of bulk data files, including employee, absence and notification data.",
    DATA_ADMIN_ACTION_TEXT: "Visit Data Admin",
    HIERARCHY_ADMIN: "Hierarchy Admin",
    HIERARCHY_ADMIN_DESCRIPTION:
      "Here you can perform loading of bulk data files, including employee, absence and notification data.",
    HIERARCHY_ADMIN_ACTION_TEXT: "View Hierarchy",
    EMPLOYEE_ADMIN: "Employee Admin",
    EMPLOYEE_ADMIN_DESCRIPTION:
      "Search for, access and edit the details of a specific employee record, including their personal details, employment details and notification set-up.",
    EMPLOYEE_ADMIN_ACTION_TEXT: "Search for an Employee",
    SERVICE_ADMIN: "Service Admin",
    SERVICE_ADMIN_DESCRIPTION:
      "Perform service administration, including the configuration of alerts, reports, absence recording rules, notifications, return to work interviews and much more.",
    SERVICE_ADMIN_ACTION_TEXT: "View Service Summary",
    NOT_FOUND_PAGE_DESCRIPTION:
      "The page you are trying to access doesn't exist. Try using a different link or return to the homepage.",
    // Menu
    CLIENT: "Client",
    DATA: "Data",
    SERVICE: "Service",
    EMPLOYEE: "Employee",
    EMPLOYEES: "Employees",
    HIERARCHY: "Hierarchy",
    SEE_ALL_CLIENTS: "See All Clients",
    THIRD_PARTY: "Third Party",
    HISTORIC: "Historic",
    SMS_OUTBOUND: "Out",
    SMS_INBOUND: "In",
    NEWS_CHANNEL: "News Channel",
    NEWS_MODAL_TITLE: "The Shape of Things to Come!",
    // Form errors
    REQUIRED_FIELD: "This field is required",
    INCORRECT_PATTERN: "Incorrect field value provided",
  },
  options: {
    suppress_warnings: true,
  },
};

export const systemMessages = {
  en: {
    ...clientMessages.en,
    ...employeeMessages.en,
    ...hierarchyMessages.en,
    ...managementMessages.en,
    ...profileMessages.en,
    ...recordingMessages.en,
    ...reportingMessages.en,
    ...serviceMessages.en,
    ...shared.en,
    // COMMON
    SUCCESSFULLY_DELETED: "Successfully deleted",
    CALLBACK_ADDED: "Callback was successfully added",
    CALLBACK_UPDATED: "Callback was successfully updated",
    CALLBACK_REMOVED: "Callback was successfully removed",
    NURSE_TRANSFER_DECLINED: "Nurse transfer declined",
    NURSE_TRANSFER_ACCEPTED: "Nurse transfer accepted",
  },
};
